import { nameOf } from '../utils/object-utils.js';
import { getDecoratorType } from '../utils/ts-utils.js';
import { Metadata } from './metadata.js';

const CLASS_STORE = 'workbench:class:store';
const METHOD_STORE = 'workbench:method:store';
const PROPERTY_STORE = 'workbench:property:store';
const PARAM_STORE = 'workbench:param:store';
/**
 * 通过 Metadata 来存储装饰器信息
 * 预留，后续所有的 decorator 都通过 Store 来记录信息
 * 可通过 Store 来创建 decorator
 *
 * @public
 */
class Store {
    constructor(args) {
        const [target, propertyKey, descriptor] = args;
        this.map = (() => {
            switch (getDecoratorType(args)) {
                case 'parameter': {
                    const store = this.storeGet(PARAM_STORE, target, propertyKey);
                    if (!store.has(`${descriptor}`)) {
                        store.set(`${descriptor}`, new Map());
                    }
                    return store.get(`${descriptor}`);
                }
                case 'property':
                    return this.storeGet(PROPERTY_STORE, target, propertyKey);
                case 'method':
                    return this.storeGet(METHOD_STORE, target, propertyKey);
                case 'class':
                    return this.storeGet(CLASS_STORE, target);
            }
        })();
    }
    static from(...args) {
        return new Store(args);
    }
    storeGet(key, ...args) {
        const registry = Metadata;
        if (!registry.has(key, ...args)) {
            registry.set(key, new Map(), ...args);
        }
        return registry.get(key, ...args);
    }
    static decorate(fn) {
        return ((...parameters) => {
            const store = Store.from(...parameters);
            const result = fn(store, parameters);
            if (typeof result === 'function') {
                result(...parameters);
            }
            return parameters[2];
        });
    }
    set(key, metadata) {
        this.map.set(nameOf(key), metadata);
        return this;
    }
    get(key) {
        return this.map.get(nameOf(key));
    }
    clear() {
        return this.map.clear();
    }
}

export { CLASS_STORE, METHOD_STORE, PARAM_STORE, PROPERTY_STORE, Store };
//# sourceMappingURL=store.js.map
